<script setup>
import { Dropdown } from 'floating-vue';
import { useI18n } from 'vue-i18n';
import Icon from 'dashboard/components-next/icon/Icon.vue';

const { t } = useI18n();
</script>

<template>
  <Dropdown
    theme="tooltip"
    :triggers="['hover', 'focus']"
    :popper-triggers="['hover']"
    placement="top"
    class="inline-flex"
  >
    <button
      type="button"
      class="inline-flex items-center p-0 rounded text-n-slate-10 hover:text-n-slate-12"
      :aria-label="t('PIXEL_FIELD_HINT.TITLE')"
    >
      <Icon icon="i-lucide-info" class="size-3.5" />
    </button>
    <template #popper>
      <div class="max-w-64 p-1 text-xs">
        <p class="m-0 text-white">{{ t('PIXEL_FIELD_HINT.TITLE') }}</p>
        <p class="mt-1 mb-0 text-white/70">
          {{ t('PIXEL_FIELD_HINT.DESCRIPTION') }}
        </p>
      </div>
    </template>
  </Dropdown>
</template>
